import { do_interaction } from './Analytics_Custom';
export function selectMapZoom() {
    do_interaction(`DPH CDI|LEGEND, ZOOM`);
}
export function selectMapClassification({ classificationType }) {
    do_interaction(`DPH CDI|LEGEND, CLASSTYPE, ${classificationType}`);
}
export function selectMapClasses({ numberOfClasses}) {
    do_interaction(`DPH CDI|LEGEND, CLASSES, ${numberOfClasses}`);
}
export function selectMapSelection() {
    do_interaction(`DPH CDI|MAPSELECTION, STATE`);
}
export function selectMapIndicatorLink() {
    do_interaction(`DPH CDI|MAPSELECTION, INDICATORLINK`);
}